import { FAQ as FAQ_IDS } from "@/constants/testIds";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  { q: "How much life insurance do I actually need?", a: "A common rule of thumb is 10–12x your annual income, plus mortgage and future college costs. Our agents will run a needs analysis with you — most families land between $250k and $1M of term coverage." },
  { q: "Do I need a medical exam?", a: "Not always. Many of our carriers offer accelerated underwriting up to $1M with no exam — just a few health questions and a prescription history check. Older applicants may qualify for guaranteed-issue final expense with no exam." },
  { q: "How long does approval take?", a: "Simplified policies are often approved in 24–72 hours. Fully underwritten policies with a paramedical exam typically take 2–4 weeks. We'll set expectations up front based on your product choice." },
  { q: "Will my rate go up later?", a: "With Term Life and Whole Life, your premium is locked in for the entire term or for life. Indexed Universal Life premiums are flexible, but the cost of insurance is disclosed in writing before you sign." },
  { q: "What happens if I miss a payment?", a: "Every carrier offers a 30-day grace period. We'll also help you set up auto-pay during enrollment and check in annually to make sure your policy stays in force." },
  { q: "Are quotes really free?", a: "Yes — and there's no obligation. Insurance carriers pay our brokerage a commission when you choose a policy. You never write Faith Family Finance a check." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid={FAQ_IDS.section} className="py-16 sm:py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4">Honest answers</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-primary leading-[1.05]">
              Questions,<br />
              <em className="not-italic text-accent">answered plainly.</em>
            </h2>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {items.map((it, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={FAQ_IDS.item(i)}
                  className="border-b border-border/60 py-2"
                >
                  <AccordionTrigger className="text-left text-lg font-serif text-primary hover:no-underline py-5">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base leading-relaxed text-muted-foreground pb-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
